import { render, staticRenderFns } from "./CountDown.vue?vue&type=template&id=652fd7f6&scoped=true&"
import script from "./CountDown.vue?vue&type=script&lang=js&"
export * from "./CountDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652fd7f6",
  null
  
)

export default component.exports